export const cartKey = {
  all: ['cart'] as const,
  carts: (cart_group_ids?: number[]) => [...cartKey.all, cart_group_ids ?? ''] as const,
  count: () => [...cartKey.all, 'count'] as const,
};
